import React, {Component} from 'react';
import { NavLink } from "react-router-dom";
import { Trans } from 'react-i18next';

class SearchTabs extends Component {
  render() {
    return (
      <div className="venue-finder-tabs fs-s">
        <NavLink to={"/map"} activeClassName="venue-finder-tabs__item venue-finder-tabs__item--map is-map" className="venue-finder-tabs__item venue-finder-tabs__item--map"><Trans i18nKey="search_tabs.label_map">Map</Trans></NavLink>
        <NavLink to={"/list"} activeClassName="venue-finder-tabs__item venue-finder-tabs__item--list is-list" className="venue-finder-tabs__item venue-finder-tabs__item--list"><Trans i18nKey="search_tabs.label_list">List</Trans></NavLink>
      </div>
    );
  }
}

export default SearchTabs;

